export default __webpack_public_path__ + "static/media/bouncingball.13c0bd22.mp4";